(() => {
  function setup(scope) {
    scope.querySelectorAll('.mh-world').forEach(world => {
      const track = world.querySelector('.mh-world__slides');
      const tabs = [...world.querySelectorAll('.mh-world__tab')];
      if (!track || track.dataset.ready) return;
      track.dataset.ready = 'true';
      tabs.forEach((tab, index) => tab.addEventListener('click', event => { event.preventDefault(); track.scrollTo({left:index * track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); }));
      const sync = () => { const index = Math.round(track.scrollLeft / track.clientWidth); tabs.forEach((tab, i) => { tab.dataset.active = String(i === index); if (i === index) tab.setAttribute('aria-current','true'); else tab.removeAttribute('aria-current'); }); };
      track.addEventListener('scroll', sync, {passive:true});
      world.addEventListener('shopify:block:select', event => { const slide = event.target.closest('.mh-world__slide'); if (slide) track.scrollTo({left:slide.offsetLeft,behavior:'instant'}); });
      sync();
    });
    scope.querySelectorAll('.mh-hero').forEach(hero => {
      const video = hero.querySelector('video');
      const button = hero.querySelector('.mh-video-toggle');
      if (!video || !button || button.dataset.ready) return;
      button.dataset.ready = 'true'; button.hidden = false;
      const update = () => { button.setAttribute('aria-pressed', String(video.paused)); button.setAttribute('aria-label', video.paused ? 'Play campaign video' : 'Pause campaign video'); button.querySelector('span').textContent = video.paused ? 'Play video' : 'Pause video'; };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay = false; video.pause(); }
      video.addEventListener('play', update); video.addEventListener('pause', update);
      button.addEventListener('click', () => { if (video.paused) video.play().catch(update); else video.pause(); });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document)); else setup(document);
  document.addEventListener('shopify:section:load', e => setup(e.target));
})();
